import React, { Component } from "react";
import { AskAnExpertInputField } from "./form/AskAnExpertInputField";
import { AskAnExpertTextArea } from "./form/AskAnExpertTextArea";
import { AskAnExpertThankYou } from "./form/AskAnExpertThankYou";
import { AskAnExpertAlert } from "./form/AskAnExpertAlert";
import {
  validateName
} from "../../../../helpers/genericHelpers";
import { requestHelpers } from '../../../../helpers';

class AskAnExpertForm extends Component {
  state = {
    fullName: "",
    businessName: "",
    contactEmail: "",
    contactNumber: "",
    businessSector: "",
    body: "",
    bodyLength: 0,
    isFetching: false,
    success: false,
    errors: {}
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onChangePhone = e => {
    this.setState({ contactNumber: e.target.value });
  };

  onChangeTextArea = e => {
    this.setState({
      [e.target.name]: e.target.value,
      bodyLength: e.target.value.length
    });
  };

  isEmpty = obj => {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
  };

  isValidPhoneNumber = (value) => {
    let myRe = /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i;
    let isValid = myRe.exec(value);
    return isValid;
  }

  isValidEmail = (email) => {
    let myRe = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let isValid = myRe.exec(email);
    return isValid;
  }

  onNewMessage = () => {
    this.setState({
      fullName: "",
      businessName: "",
      contactEmail: "",
      contactNumber: "",
      businessSector: "",
      body: "",
      bodyLength: 0,
      isFetching: false,
      success: false,
      errors: {}
    })
  }

  onSubmit = e => {
    e.preventDefault();
    let errors = {};
    const {
      fullName,
      contactEmail,
      contactNumber,
      businessSector,
      body
    } = this.state;

    fullName.length === 0 && (errors.fullName = "Your full name is required.");
    contactNumber.length === 0 && (errors.contactNumber = "A contact number is required.");
    businessSector.length === 0 && (errors.businessSector = "Industry/sector is required.");
    body.length === 0 && (errors.body = "A question is required.");
    fullName.trim().split(" ").length < 2 && (errors.fullName = "Full name (first name, last name) is required.");

    !!validateName(fullName) === true && (errors.fullName = "Please enter your valid full name.")
    this.isValidEmail(contactEmail) === null && (errors.contactEmail = "Please enter a valid email.")
    this.isValidPhoneNumber(contactNumber) === null && (errors.contactNumber = "Please enter a valid phone number.")
    //!!validateName(businessSector) === true && (errors.businessSector = "Please enter a valid business sector.")

      
    body.length > 2000 && (errors.body = "Please ensure your message has a amximum of 2000 characters.")

    if (!this.isEmpty(errors)) return this.setState({ errors });

    //Make errors empty
    this.setState({
      errors: {},
      isFetching: true
    });

    const objectToSend = {
      fullName: this.state.fullName,
      businessName: this.state.businessName,
      contactEmail: this.state.contactEmail,
      contactNumber: this.state.contactNumber,
      businessSector: this.state.businessSector,
      body: this.state.body,
      bodyLength: this.state.bodyLength
    }

    requestHelpers
      .authenticatedPostRequest(`/communications/askAnExpert`, objectToSend)
      .then(() => {
        //Success -> show welcome message
        return this.setState({ success: true });
      })
      .catch((errors) => {
        //console.log(errors);
        return this.setState({ 
          errors: errors.data,
          isFetching: false
        });
      });

  };

  render() {

    const {
      fullName,
      businessName,
      contactEmail,
      contactNumber,
      businessSector,
      body,
      bodyLength,
      success,
      isFetching,
      errors
    } = this.state;

    {
      //If message sent succesfully, state.success === true -> render ThankYou component
      //To check locally without sending emails how it looks like, change condition success === false
    }
    if (success === true) return <AskAnExpertThankYou onNewMessage={this.onNewMessage}/>;

    var button;

        if (isFetching) {
            button = <button className="btn btn-primary margin-bottom-3" onClick={e => e.preventDefault()}>Please wait...</button>
        } else if (!this.isEmpty(errors)) {
            button = <div className=" margin-bottom-3"><button className="btn btn-primary" >Ooops!</button><div className="padding-top alert-color">Please check the required fields above</div></div>
        } else { 
            button = <button className="btn btn-primary margin-bottom-3" type="submit">Send message</button>
        }

    return (
      <section className="container">
        <div className="row">
          <div className="col-xs-12 col-md-offset-1 col-md-10 col-xl-offset-2 col-xl-8">
            <form className="margin-y" onSubmit={this.onSubmit} noValidate>
            <div className="margin-half-bottom">
              <small className="font-italic">Required fields are marked with <span className="color-red">*</span></small>
            </div>

              <AskAnExpertInputField
                autoFocus={"autofocus"}
                label="Full Name"
                name="fullName"
                value={fullName}
                placeholder="Enter your full name"
                onChange={this.onChange}
                isRequired={true}
                error={errors.fullName}
                maxLength={80}
                type={"text"}
              />

              <AskAnExpertInputField
                label="Business Name"
                name="businessName"
                value={businessName}
                placeholder="Enter your business name"
                onChange={this.onChange}
                isRequired={false}
                error={errors.businessName}
                maxLength={80}
                type={"text"}
              />

              <AskAnExpertInputField
                label="Email"
                name="contactEmail"
                value={contactEmail}
                placeholder="Enter your email address"
                onChange={this.onChange}
                isRequired={true}
                error={errors.contactEmail}
                maxLength={80}
                type={"email"}
              />

              <AskAnExpertInputField
                label="Contact Number"
                name="contactNumber"
                value={contactNumber}
                placeholder="Enter your contact number"
                onChange={this.onChange}
                isRequired={true}
                error={errors.contactNumber}
                maxLength={20}
                type={"tel"}
              />

              <AskAnExpertInputField
                label="Industry/sector"
                name="businessSector"
                value={businessSector}
                placeholder="Enter your business industry/sector"
                onChange={this.onChange}
                isRequired={true}
                error={errors.businessSector}
                maxLength={80}
                type={"text"}
              />

              <AskAnExpertTextArea
                label="Question"
                rows={5}
                name="body"
                value={body}
                placeholder="What do you require an expert for?"
                length={bodyLength}
                onChange={this.onChangeTextArea}
                isRequired={true}
                maxLength={2000}
                error={errors.body}
                type={"text"}
              />

              <br/>

                {button}

            </form>
          </div>
        </div>
      </section>
    );
  }
}

export default AskAnExpertForm;



// WEBPACK FOOTER //
// src/client/components/site/features/askanexpert/AskAnExpertForm.js